import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { LANGUAGES } from "../i18n";

export const LanguageSwitcher = ({ testId = "lang-switcher" }) => {
  const { i18n, t } = useTranslation();
  const current = LANGUAGES.find((l) => i18n.language?.startsWith(l.code)) || LANGUAGES[0];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={testId} title={t("nav.language")}
          className="flex items-center gap-1.5 px-2.5 h-9 rounded-lg bg-elevated border border-steel text-slate-300 hover:text-cyan font-mono text-xs uppercase tracking-widest transition-colors">
          <Globe size={15} />
          <span>{current.code.toUpperCase()}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="p-1 w-44 bg-surface border-steel max-h-80 overflow-auto">
        {LANGUAGES.map((l) => (
          <button key={l.code} data-testid={`lang-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
            className={`w-full flex items-center justify-between px-3 py-2 rounded-md font-body text-sm transition-colors ${
              current.code === l.code ? "bg-elevated text-cyan" : "text-slate-300 hover:bg-elevated"
            }`}>
            <span>{l.native}</span>
            {current.code === l.code && <Check size={14} className="text-cyan" />}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};
